import { z } from 'zod'

// Default constants
const DEFAULT_AUFTRAG30_10 = {
  enabled: true
}

const DEFAULT_BEFEHL_30_FORM = {
  auftrag30_10: DEFAULT_AUFTRAG30_10
}

// Schema definitions
const Auftrag30_10Schema = z
  .object({
    enabled: z.boolean().default(DEFAULT_AUFTRAG30_10.enabled)
  })
  .default(() => structuredClone(DEFAULT_AUFTRAG30_10))

// Base schema
const Befehl30FormSchemaBase = z
  .object({
    auftrag30_10: Auftrag30_10Schema
  })
  .default(() => structuredClone(DEFAULT_BEFEHL_30_FORM))

export const Befehl30FormSchema = Befehl30FormSchemaBase

// Validation schema factory
export const createBefehl30FormValidationSchema = () => {
  return Befehl30FormSchemaBase
}

export type Befehl30FormData = z.infer<typeof Befehl30FormSchemaBase>
